import { render, staticRenderFns } from "./IssuePanel.vue?vue&type=template&id=4a374efa&scoped=true"
import script from "./IssuePanel.vue?vue&type=script&lang=js"
export * from "./IssuePanel.vue?vue&type=script&lang=js"
import style0 from "./IssuePanel.vue?vue&type=style&index=0&id=4a374efa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a374efa",
  null
  
)

export default component.exports